import {CsvReadItem} from './PromotionQuestionsState';
import api from '../../api';
import {buildValidator} from 'src_common/common/mobx-utils/buildValidator';
import {ResponseAddQuestionIO} from './types';
import * as t from 'io-ts';

const decodeResponse = buildValidator('add marketing question -> ResponseIO', ResponseAddQuestionIO, true);

export const addQuestion = (question: Partial<CsvReadItem>): Promise<CsvReadItem> => {
    return new Promise((resolve, reject) => {
        const url = '/marketing-questions';
        const payload = {
            name: question.name,
            possibleAnswers: question.possibleAnswers,
            active: question.active,
            fileName: question.fileName,
            uploadedAt: question.uploadedAt?.toString()
        };

        api.post(url, payload)
            .then((data: t.TypeOf<typeof ResponseAddQuestionIO>) => {
                const decodeResult = decodeResponse(data);
                if (decodeResult instanceof Error) {
                    reject(decodeResult);
                }
                resolve(data);
            }).catch((error: Error)=>{
                reject(error);
            });
    });
};
